/* global Box */

Box.Application.addModule('sv-navigation', context => {
    let didScroll
    let lastScrollTop = 0
    const DELTA = 50
    let intervalID
    let navBar = document.querySelector('.navbar')
    let navbarHeight = navBar.offsetHeight
    let header = document.querySelector('.sv-header-wrapper')
    let burgerMenu = document.querySelector('.navbar-burger')
    let navWrapper = document.querySelector('.navbar-wrapper')
    let navBarItems = document.getElementsByClassName('navbar-item')

    let _detectMq = () => {
        let burgerMenuOpen = navBar.classList.contains('is-mobile')
        if (burgerMenuOpen) {
            let isDesktop = document.documentElement.clientWidth > 1024
            if (isDesktop) {
                toggleBurgerMenu()
            }
        }
    }

    function toggleBurgerMenu() {
        navBar.classList.toggle('is-mobile')
        document.body.classList.toggle('mobile-nav')
        header.classList.toggle('is-nav-active')
    }

    let _initNav = () => {
        window.addEventListener('scroll', function () {
            didScroll = true
        })

        showOnScroll()

        intervalID = setInterval(() => {
            if (didScroll) {
                showOnScroll()
                didScroll = false
            }
        }, 500)
    }

    let _setActive = () => {
        let currentLocation = location.pathname
        for (let element of navBarItems) {
            if (element.getAttribute('href') === currentLocation) {
                element.classList.add('current')
            }
        }
    }

    function showOnScroll() {
        let distanceToTop = document.documentElement.scrollTop

        if (Math.abs(lastScrollTop - distanceToTop) <= DELTA) {
            return
        }

        if (distanceToTop > lastScrollTop && distanceToTop > navbarHeight) {
            // Scroll Down
            navWrapper.classList.remove('nav-down')
            navWrapper.classList.add('nav-up', 'scrolled')
        } else {
            // Scroll Up
            if (distanceToTop + window.innerHeight < document.body.clientHeight) {
                navWrapper.classList.remove('nav-up')
                navWrapper.classList.add('nav-down')
            }
        }

        if (distanceToTop <= 200) {
            navWrapper.classList.remove('scrolled')
        }

        lastScrollTop = distanceToTop
    }

    return {

        init: function () {
            _setActive()
            _initNav()
            _detectMq()
            window.addEventListener('resize', _detectMq, false)
            burgerMenu.addEventListener('click', toggleBurgerMenu)
        },

        destroy: function () {
            clearInterval(intervalID)
            navWrapper.remove()
        }
    }
})



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-navigation.js